import angular from 'angular'
import baseTemp from './views/baseTemplate.html'
import taxClassTemp from './views/taxClassTemplate.html'
import templateGroup from './views/templateGroup.html'
import config from './config'
import utils from 'utils'

const popupSelectModule = angular
    .module('app.popupSelect2', [])

export default popupSelectModule.name
popupSelectModule.component('taxClassPopup', {
    template: `<div class="clearfix et-popup-select">
        <input autocomplete="off" type="text" ng-model="$ctrl.model" class="form-control f-fl et-popup-select-ipt"  uib-typeahead="n.taxName as n.mergeCodeAndTaxName for n in $ctrl.getTaxClassList($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="$ctrl.noResults" typeahead-on-select="$ctrl.getTaxClassInfo($item, $model, $label, $event)" required ng-blur="$ctrl.blurFn($ctrl.noResults)">
        <div class="et-popup-select-icon f-fl" ng-click="$ctrl.openPop()" style="border-left:none;">
            <i class="icon iconfont icon-shurukuangtanchuang"></i>
        </div>
    </div>`,

    /**
     *
     *          type  弹窗类型             string
     *          model 输入框显示的字段，由用户决定
     *          callback 在选择数据后的回调 选中的object通过CB传给用户
     */
    bindings: {
        type: '@',
        model: '=',
        callback: '&',
    },
    controller: ['$uibModal', '$http', function ($uibModal, $http) {
        // 税收编码输入选择匹配数据
        this.getTaxClassList = function getTaxClassList (val) {
            if (this.type === 'car') {
                return $http.get(`${host.etcloudOvat}settings/sysVehicleGood/qryVehicleTaxClassList`, {
                    params: {
                        taxName: `${val}`,
                    },
                }).then((response) => response.data.value.map((item) => $.extend({}, {
                    mergeCodeAndTaxName: `${item.mergeCode}${item.taxName}`,
                }, item)))
            }
            return $http.get(`${IS_PROVIDER ? host.etcloud : host.etcloudOvat}${IS_PROVIDER ? 'supplier/sysSupplierGoodsInfo' : 'settings/sysGoodsInfo'}/getTaxClassList`, {
                params: {
                    taxName: `${val}`,
                },
            }).then((response) => response.data.value.map((item) => $.extend({}, {
                mergeCodeAndTaxName: `${item.mergeCode}${item.taxName}`,
            }, item)))
        }
        // 税收编码输入选择匹配后的逻辑
        this.getTaxClassInfo = function ($item) {
            this.callback && this.callback({
                $item,
            })
        }
        // 无匹配数据失去焦点
        this.blurFn = function blurFn (v) {
            if (v) this.model = ''
        }
        this.openPop = function () {
            const _that = this
            $uibModal.open({
                template: taxClassTemp,
                openedClass: 'mod-modal mod-modal-hg',
                controller: ['$scope', '$uibModalInstance', 'httpRequest', '$timeout', 'config', function modalFn ($scope, $uibModalInstance, httpRequest, $timeout, config) {
                    $scope.cancel = () => {
                        $uibModalInstance.dismiss()
                    }
                    httpRequest.get_dictByTypeArr(['is_sum']).then((res) => {
                        $scope.dictData = res.data.value
                    })
                    const type = config.type == 'car' ? 1 : ''
                    $scope.queryParam = {
                        pageNum: 1,
                        pageSize: 10,
                        param: {
                            pid: '',
                            allStr: '',
                            type,
                            deep: true,
                        },
                    }
                    $scope.isClosed = false
                    $scope.listData = []
                    $scope.queryList = function queryList () {
                        httpRequest.post_getSysTaxClassList($scope.queryParam).then((res) => {
                            if (res.data.success) {
                                $scope.listData = res.data.value.list
                                $scope.totalItems = res.data.value.total
                            }
                        })
                    }
                    $scope.queryList()
                    // 初始树结构获取
                    httpRequest.post_getSysTaxClassList({
                        pageNum: 1,
                        pageSize: 10,
                        param: {
                            pid: 0,
                        },
                    }).then((res) => {
                        if (res.data.success) {
                            $scope.treeListData = res.data.value.list
                        }
                    })
                    /**
                     * 树切换方法，无参数为总目录切换，传参为子目录切换
                     */
                    $scope.toggleTree = function toggleTree (e, obj) {
                        $('.pop-tree-text').removeClass('et-pop-select-acitve')
                        if (arguments.length) {
                            obj.isOpened = !obj.isOpened
                            // 添加active类名
                            if ($(e.target).parent('div').length) {
                                $(e.target).parent('div').children('.pop-tree-text').addClass('et-pop-select-acitve')
                            } else {
                                $(e.target).children('.pop-tree-text').addClass('et-pop-select-acitve')
                            }
                        } else {
                            $scope.isClosed = !$scope.isClosed
                            $('.tax-class-tree').children('div').children('.pop-tree-text').addClass('et-pop-select-acitve')
                        }
                        // 发送请求插入子目录数据
                        $scope.queryParam.param.pid = obj ? obj.mergeCode : ''
                        httpRequest.post_getSysTaxClassList({
                            pageNum: 1,
                            pageSize: 0,
                            param: {
                                pid: $scope.queryParam.param.pid,
                            },
                        }).then((res) => {
                            if (res.data.success) {
                                if (obj) obj.treeListData = res.data.value.list
                            }
                        })
                        httpRequest.post_getSysTaxClassList($scope.queryParam).then((res) => {
                            if (res.data.success) {
                                $timeout(() => {
                                    $scope.listData = res.data.value.list
                                    $scope.totalItems = res.data.value.total
                                })
                            }
                        })
                    }
                    $scope.title = '税收分类编码选择'
                    $scope.ok = (obj) => {
                        // 调用接口使返回数据与输入匹配数据结构一致
                        if (!obj.taxRate && obj.taxRate !== 0) return
                        $http.get(`${host.etcloudOvat}settings/sysGoodsInfo/getTaxClassInfo`, {
                            params: {
                                taxName: obj.taxName,
                            },
                        }).then((res) => {
                            $uibModalInstance.close(res.data.value)
                        })
                    }
                }],
                animation: true,
                resolve: {
                    config () {
                        return {
                            type: _that.type,
                            callback: _that.callback,
                        }
                    },
                },
            }).result.then((obj) => {
                _that.callback && _that.callback({
                    $item: obj,
                })
            })
        }
    }],
})

popupSelectModule.component('popupSelectInput', {
    template: `
        <div class="clearfix et-popup-select popup-select-input-father">
            <input autocomplete="off" type="text" ng-model="$ctrl.model" class="form-control f-fl et-popup-select-ipt table-text-overflow"  uib-typeahead="n[$ctrl.model] as n.codeAndName for n in $ctrl.getNameList($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="$ctrl.noResults" typeahead-on-select="$ctrl.getNameInfo($item, $model, $label, $event)" required ng-blur="!$ctrl.noblur && $ctrl.blurFn($event)" title="{{$ctrl.model}}" ng-dblclick="$ctrl.dblClick($event)">
            <!-- 表格提示 -->
            <div class="popup-select-input-dropdown-box" ng-if="$ctrl.model && !$ctrl.noResults && !$ctrl.hiddenFlag" ng-mousedown="$ctrl.noblur=true;$event.stopPropagation()" ng-mouseup="$ctrl.noblur=false;">
                <div class="popup-select-input-dropdown-box1">
                    <ul class="clearfix">
                        <li class="popup-select-input-col-code">编码</li>
                        <li class="popup-select-input-col-name">商品名称</li>
                        <li class="popup-select-input-col-spec">规格型号</li>
                        <li class="popup-select-input-col-unit">单位</li>
                        <li class="popup-select-input-col-tax">税率</li>
                    </ul>
                </div>
                <div class="popup-select-input-dropdown-box2">
                    <ul class="clearfix" ng-repeat="i in $ctrl.matchItems" ng-click="$ctrl.getNameInfo(i)">
                        <li class="popup-select-input-col-code" title="{{i.goodsCode}}">{{i.goodsCode}}</li>
                        <li class="popup-select-input-col-name" title="{{i.goodsName}}">{{i.goodsName}}</li>
                        <li class="popup-select-input-col-spec" title="{{i.specifications}}">{{i.specifications}}</li>
                        <li class="popup-select-input-col-unit" title="{{i.measureUnit}}">{{i.measureUnit}}</li>
                        <li class="popup-select-input-col-tax" title="{{i.taxRate*100+'%'}}">{{i.taxRate*100+'%'}}</li>
                    </ul>
                </div>
            </div>  
        </div>
    `,
    bindings: {
        type: '@',
        model: '=',
        callback: '&',
        code: '@', // 可选参数，用于区分用户信息 'creditCode','certificateNo'
        noCertificateNo: '@', // 可选参数，区分是否需要查询身份证号
    },
    controller: ['httpRequest', '$element', function (httpRequest, $element) {
        const scope = this
        let configObj = null
        scope.noResults = false
        // 表格提示
        scope.matchItems = []
        scope.noblur = false
        scope.hiddenFlag = true

        scope.$onInit = function () {
            configObj = config[scope.type]
            // config设置展示字段默认值
            configObj.showCode = configObj.showCode || 'code'
            configObj.showName = configObj.showName || 'name'
            // 设置无匹配项不保存类型
            // if (scope.type == 'carInfo' || scope.type == 'goodsInfo') scope.notSave = true
        }
        // 失去焦点逻辑
        function iptFn () {
            if (!scope.noResults || (scope.type != 'carInfo' && scope.type != 'goodsInfo')) return
            $($element[0]).parent().parent().find('popup-group-btn .et-popup-select-icon')
                .click()
        }
        scope.blurFn = iptFn
        scope.dblClick = function () {
            scope.blurFn = null
            iptFn()
            setTimeout(() => {
                scope.blurFn = iptFn
            }, 1000)
        }
        scope.queryParam = {
            pageSize: 100,
            pageNum: 1,
            param: {
                allStr: '',
            },
        }
        // 输入选择匹配数据
        scope.getNameList = function getNameList (val) {
            const $activeEle = $(document.activeElement)
            scope.queryParam.param.allStr = val
            if (scope.type == 'buyerName') {
                return httpRequest.post_qryByCodeOrName(val).then((res) => res.data.value.map((item) => $.extend({}, {
                    codeAndName: `${item.customerName} ${item.creditCode}`,
                }, item)))
            } if (scope.type == 'buyerInfo') {
                scope.queryParam.param.certificateNo = scope.noCertificateNo ? '1' : 0
                scope.queryParam.param.status = 1
                return httpRequest[configObj.urlApi](scope.queryParam).then((res) => res.data.value.list.map((item) => ({ codeAndName: `${scope.code == 'creditCode' ? item.creditCode : scope.code == 'certificateNo' ? item.certificateNo : item.customerCode} ${item.customerName}`, ...item })))
            }
            if (configObj.hasStatus) scope.queryParam.param.status = 1
            if (scope.type == 'goodsInfo') {
                httpRequest[configObj.urlApi](scope.queryParam).then((res) => {
                    scope.matchItems = res.data.value.list
                    if (scope.matchItems.length > 0) {
                        scope.noResults = false
                        scope.hiddenFlag = false
                        $(document).unbind('mousedown').on('mousedown', (e) => {
                            if ($(e.target).is($activeEle)) return
                            scope.hiddenFlag = true
                            $(document).unbind('mousedown')
                        })
                    } else {
                        scope.noResults = true
                    }
                })
            } else {
                return httpRequest[configObj.urlApi](scope.queryParam).then((res) => res.data.value.list.map((item) => ({ codeAndName: `${item[configObj.showCode]} ${item[configObj.showName]}`, ...item })))
            }
        }
        // 选择匹配项
        scope.getNameInfo = function getNameInfo ($item) {
            if (scope.type == 'goodsInfo') {
                $item.isGoodsInfoTab = 1
            }
            scope.callback && scope.callback({
                $item,
            })
            scope.hiddenFlag = true
            scope.matchItems = []
            $(document).unbind('mousedown')
        }
    }],
})

popupSelectModule.component('popupSelectBtn', {
    template: `
            <div class="clearfix et-popup-select">
                <div class="et-popup-select-icon f-fl" ng-click="$ctrl.openPop()">
                    <i class="icon iconfont icon-shurukuangtanchuang"></i>
                </div>
            </div>
        `,
    bindings: {
        type: '@',
        callback: '&',
    },
    controller: ['$uibModal', function ($uibModal) {
        this.openPop = function () {
            const scope = this
            const configObj = config[scope.type]
            $uibModal.open({
                template: baseTemp,
                openedClass: configObj.modalClass,
                controller: ['$scope', '$uibModalInstance', 'httpRequest', 'config', function modalFn ($scope, $uibModalInstance, httpRequest, config) {
                    $scope.cancel = () => {
                        $uibModalInstance.dismiss()
                    }
                    $scope.tableList = config.tableList
                    $scope.isDouble = config.isDouble
                    $scope.isSm = config.isSm
                    $scope.queryParam = {
                        pageNum: 1,
                        pageSize: 10,
                        param: {
                            allStr: '',
                        },
                    }
                    $scope.listData = []
                    $scope.taxRatePercent = function taxRatePercent (val) {
                        if (+val === val) {
                            val = `${val * 100}%`
                        }
                        return val
                    }
                    $scope.queryList = function queryList () {
                        if (config.hasStatus) $scope.queryParam.param.status = 1
                        httpRequest[configObj.urlApi]($scope.queryParam).then((res) => {
                            if (res.data.success) {
                                $scope.listData = res.data.value.list
                                $scope.totalItems = res.data.value.total
                            }
                        })
                    }
                    $scope.queryList()
                    $scope.title = config.title
                    $scope.ok = (obj) => {
                        $uibModalInstance.close(obj)
                    }
                }],
                animation: true,
                resolve: {
                    config () {
                        return configObj
                    },
                },
            }).result.then((obj) => {
                scope.callback && scope.callback({
                    $item: obj,
                })
            })
        }
    }],
})

popupSelectModule.component('popupGroupBtn', {
    template: `
            <div class="clearfix et-popup-select">
                <div class="et-popup-select-icon f-fl" ng-click="$ctrl.openPop()">
                    <i class="icon iconfont icon-shurukuangtanchuang"></i>
                </div>
            </div>
        `,
    bindings: {
        type: '@',
        callback: '&',
        model: '<',
        hideTab: '@'
    },
    controller: ['$uibModal', function ($uibModal) {
        this.openPop = function () {
            const scope = this
            const configObj = config[scope.type]
            configObj.model = scope.model ? scope.model.replace(/^\*[^]*?\*/, '') : scope.model
            $('.goods-detail-modal').hide()
            $uibModal.open({
                template: templateGroup,
                openedClass: configObj.modalClass,
                windowClass: 'goods-info-modal',
                controller: ['$scope', '$uibModalInstance', 'httpRequest', '$timeout', '$uibModal', '$http', 'config', 'hideTab', function modalFn ($scope, $uibModalInstance, httpRequest, $timeout, $uibModal, $http, config, hideTab) {
                    $timeout(() => {
                        $('.goods-info-modal').hide()
                        $('.goods-info-modal').show()
                    })
                    $scope.cancel = () => {
                        $uibModalInstance.dismiss()
                    }
                    $scope.title = config.title
                    $scope.hideTab = hideTab
                    $scope.ok = (obj) => {
                        if (!obj.taxRate && obj.taxRate !== 0) return
                        if ($scope.tabVal == 1) {
                            if ($scope.title == "商品信息") {
                                obj.isGoodsInfoTab = 1 // 商品信息tab页标识
                            }
                            $uibModalInstance.close(obj)
                        } else if ($scope.tabVal == 2) {
                            $uibModalInstance.dismiss()
                            $http.get(`${host.etcloudOvat}settings/sysGoodsInfo/getTaxClassInfo`, {
                                params: {
                                    taxName: obj.taxName,
                                },
                            }).then((res) => {
                                res.data.value.goodsName = $scope.queryParam.param.allStr ? $scope.queryParam.param.allStr : res.data.value.taxName
                                $uibModal.open({
                                    templateUrl: 'goodCheck.html',
                                    openedClass: 'mod-modal mod-modal-lg',
                                    controller: ['$scope', '$uibModalInstance', 'httpRequest', 'logger', 'items1', ($scope, $uibModalInstance, httpRequest, logger, items1) => {
                                        console.log(items1)
                                        httpRequest.get_dictByTypeArr(['is_privilege']).then((res) => {
                                            $scope.dictData = res.data.value
                                        })
                                        $scope.isCar = scope.type == 'carInfo' ? 1 : 0
                                        $scope.goodInfo = items1
                                        $scope.isCar && ($scope.goodInfo.vehicleType = items1.goodsName)
                                        $scope.goodInfo.typeId = 0
                                        $scope.goodInfo.levyWay = '1'
                                        $scope.goodInfo.taxInclud = '1'
                                        $scope.goodInfo.status = '1'
                                        $scope.goodInfo.taxMergeCode = items1.mergeCode
                                        $scope.goodInfo.taxMergeName = items1.taxName
                                        $scope.goodInfo.taxClassName = items1.taxName
                                        if (!(items1.discountOptionList && items1.discountOptionList.length < 2)) {
                                            $scope.goodInfo.isPrivilege = '0'
                                            $scope.goodInfo.taxRate = items1.taxRateList[0]
                                            $scope.isPrivilegeFlag = true
                                            $scope.goodInfo.privilegeType = ''
                                        } else {
                                            $scope.goodInfo.isPrivilege = '1'
                                            $scope.isPrivilegeFlag = false
                                            $scope.goodInfo.privilegeType = items1.taxSpecialManageList[0]
                                        }
                                        if (items1.taxSpecialManageList.length === 1
                                            && items1.taxSpecialManageList[0] === '不征税'
                                            && items1.taxRateList[0] === 0) {
                                            $scope.isTaxClassLocked = true
                                            $scope.goodInfo.isPrivilege = '1'
                                            $scope.goodInfo.privilegeType = items1.taxSpecialManageList[0]
                                            $scope.goodInfo.taxRate = 0
                                            $scope.taxRateOptions = [0]
                                        } else {
                                            getTaxRateOptions().then(setTaxRate)
                                        }
                                        // 是否享受优化政策
                                        $scope.changeIsPrivilege = function changeIsPrivilege () {
                                            if ($scope.goodInfo.isPrivilege === '0') {
                                                $scope.isPrivilegeFlag = true
                                                $scope.goodInfo.privilegeType = ''
                                            } else {
                                                $scope.goodInfo.privilegeType = items1.taxSpecialManageList[0]
                                                $scope.isPrivilegeFlag = false
                                            }
                                            getTaxRateOptions().then(setTaxRate)
                                        }
                                        // 优惠政策变化
                                        $scope.changePrivilegeType = function changePrivilegeType () {
                                            getTaxRateOptions().then(setTaxRate)
                                        }
                                        // 获取商品税率
                                        function getTaxRateOptions () {
                                            const rateReq = {
                                                taxMergeCode: $scope.goodInfo.taxMergeCode,
                                                privilegeType: encodeURIComponent($scope.goodInfo.privilegeType || ''),
                                                invType: scope.type == 'carInfo' ? 12 : -1,
                                            }
                                            return httpRequest.get_qryGoodsInfoTax(rateReq).then((res) => {
                                                $scope.taxRateOptions = res.data.value
                                            })
                                        }

                                        function setTaxRate () {
                                            if ($scope.goodInfo.isPrivilege === '1') {
                                                $scope.goodInfo.taxRate = $scope.taxRateOptions[0]
                                            } else {
                                                $scope.goodInfo.taxRate = items1.taxRateList[0]
                                            }
                                        }
                                        $scope.cancel = () => {
                                            $uibModalInstance.dismiss()
                                        }
                                        $scope.ok = (v) => {
                                            if (!$scope.goodInfo.goodsName && !$scope.goodInfo.vehicleType) return logger.logError('商品名称必填')
                                            if (utils.isRefinedOil($scope.goodInfo.taxMergeCode) && $scope.goodInfo.measureUnit !== '吨' && $scope.goodInfo.measureUnit !== '升') {
                                                return logger.logError('成品油商品，计量单位必为“吨”或“升”')
                                            }
                                            const httpStr = $scope.isCar ? 'post_addVehicleGood' : 'post_addGoodsInfo'
                                            if (v) {
                                                httpRequest[httpStr]($scope.goodInfo, '新增成功').then(() => {
                                                    $uibModalInstance.close($scope.goodInfo)
                                                })
                                            } else {
                                                $uibModalInstance.close($scope.goodInfo)
                                            }
                                        }
                                    }],
                                    animation: true,
                                    resolve: {
                                        items1 () {
                                            return res.data.value
                                        },
                                    },
                                }).result.then((item) => {
                                    scope.callback && scope.callback({
                                        $item: item,
                                    })
                                })
                            })
                        }
                    }
                    let loading
                    $scope.queryParam = {
                        pageNum: 1,
                        pageSize: 10,
                        param: {
                            allStr: config.model,
                        },
                    }
                    $scope.tabChange = function tabChange (v) {
                        loading = window.layer.msg('数据加载中...', {
                            time: 0,
                            skin: 'layer-loading-self',
                            icon: 16,
                            shade: 0.5,
                        })
                        if (v == 1) {
                            $scope.queryParam.param.type = ''
                            $scope.queryParam.param.deep = ''
                        } else if (v == 2) {
                            $scope.queryParam.param.type = type
                            $scope.queryParam.param.deep = true
                            // 初始树结构获取
                            httpRequest.post_getSysTaxClassList({
                                pageNum: 1,
                                pageSize: 10,
                                param: {
                                    pid: 0,
                                },
                            }).then((res) => {
                                if (res.data.success) {
                                    $scope.treeListData = res.data.value.list
                                }
                            })
                        }
                        $scope.queryList(v)
                        $scope.tabVal = v
                    }
                    const type = scope.type == 'carInfo' ? 1 : ''
                    $scope.tableList = config.tableList
                    $scope.isDouble = config.isDouble
                    $scope.isSm = config.isSm
                    httpRequest.get_dictByTypeArr(['is_sum']).then((res) => {
                        $scope.dictData = res.data.value
                    })
                    $scope.isClosed = false

                    $scope.listData = []
                    $scope.taxRatePercent = function taxRatePercent (val) {
                        if (+val === val) {
                            val = `${val * 100}%`
                        }
                        return val
                    }
                    $scope.queryList = function queryList (v) {
                        if (v == 1) {
                            if (config.hasStatus) $scope.queryParam.param.status = 1
                            httpRequest[configObj.urlApi]($scope.queryParam).then((res) => {
                                if (res.data.success) {
                                    $scope.listData = res.data.value.list
                                    $scope.totalItems = res.data.value.total
                                    window.layer.close(loading)
                                }
                            })
                        } else if (v == 2) {
                            httpRequest.post_getSysTaxClassList($scope.queryParam).then((res) => {
                                if (res.data.success) {
                                    $scope.listData = res.data.value.list
                                    $scope.totalItems = res.data.value.total
                                    window.layer.close(loading)
                                }
                            })
                        }
                    }


                    /**
                     * 树切换方法，无参数为总目录切换，传参为子目录切换
                     */
                    $scope.toggleTree = function toggleTree (e, obj) {
                        $('.pop-tree-text').removeClass('et-pop-select-acitve')
                        if (arguments.length) {
                            obj.isOpened = !obj.isOpened
                            // 添加active类名
                            if ($(e.target).parent('div').length) {
                                $(e.target).parent('div').children('.pop-tree-text').addClass('et-pop-select-acitve')
                            } else {
                                $(e.target).children('.pop-tree-text').addClass('et-pop-select-acitve')
                            }
                        } else {
                            $scope.isClosed = !$scope.isClosed
                            $('.tax-class-tree').children('div').children('.pop-tree-text').addClass('et-pop-select-acitve')
                        }
                        // 发送请求插入子目录数据
                        $scope.queryParam.param.pid = obj ? obj.mergeCode : ''
                        httpRequest.post_getSysTaxClassList({
                            pageNum: 1,
                            pageSize: 0,
                            param: {
                                pid: $scope.queryParam.param.pid,
                            },
                        }).then((res) => {
                            if (res.data.success) {
                                if (obj) obj.treeListData = res.data.value.list
                            }
                        })
                        httpRequest.post_getSysTaxClassList($scope.queryParam).then((res) => {
                            if (res.data.success) {
                                $timeout(() => {
                                    $scope.listData = res.data.value.list
                                    $scope.totalItems = res.data.value.total
                                })
                            }
                        })
                    }
                }],
                animation: true,
                resolve: {
                    config () {
                        return configObj
                    },
                    hideTab () {
                        return scope.hideTab
                    }
                },
            }).result.then((obj) => {
                scope.callback && scope.callback({
                    $item: obj,
                })
            }).finally(() => {
                $('.goods-detail-modal').show()
            })
        }
    }],
})



// WEBPACK FOOTER //
// ./src/components/popupSelect2/index.js